import * as React from 'react';
import Typography from '@mui/material/Typography';
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
} from '@mui/material';
import autobind from 'autobind-decorator';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import AccountService, {
  CreateClinicResult,
} from '../../service/AccountService';

const SubmitButton = styled(Button)((props) => ({
  margin: props.theme.spacing(3, 0, 2),
  minWidth: '160px',
}));

export type ClinicDialogProps = {
  dialogState: DeleteClinicDialogState;
  account?: AccountService;
  onDelete: () => void;
};

export class DeleteClinicDialogState {
  @observable
  public open = false;
}

export type NewClinicDialogStatus = 'NORMAL' | 'LOADING' | CreateClinicResult;

@inject('account')
@observer
export default class DeleteDialog extends React.Component<ClinicDialogProps> {
  @observable
  private _status: NewClinicDialogStatus = 'NORMAL';

  @autobind
  handleClose() {
    this.props.dialogState.open = false;
  }

  getErrorMessage(): string {
    if (this._status == 'INVALID_NAME') {
      return 'Invalid Name. Must be minimum 4 characters.';
    }

    if (this._status == 'UNKNOWN_ERROR') {
      return 'An error has occured while creating the clinic. Please try again.';
    }

    return null;
  }

  render() {
    var { dialogState } = this.props;
    var errorMessage = this.getErrorMessage();

    return (
      <Dialog
        open={this.props.dialogState.open}
        onClose={this.handleClose}
        maxWidth='xs'
        fullWidth
        aria-labelledby='alert-dialog-title'
      >
        <DialogTitle
          id='alert-dialog-title'
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Typography style={{ flexGrow: 1 }}>
            Are you sure that you want delete this location?
          </Typography>
          <IconButton
            aria-label='close'
            onClick={this.handleClose}
            disabled={this._status == 'LOADING'}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogActions>
          <SubmitButton
            variant='contained'
            onClick={this.handleClose}
            color='primary'
            style={{ marginRight: 24 }}
          >
            <Typography>Cancel</Typography>
          </SubmitButton>
          <SubmitButton
            variant='contained'
            onClick={this.props.onDelete}
            color='secondary'
            style={{ marginRight: 24 }}
          >
            <Typography>Delete</Typography>
          </SubmitButton>
        </DialogActions>
      </Dialog>
    );
  }
}
